import { render, staticRenderFns } from "./CompanySelector.vue?vue&type=template&id=6a0e9d22&"
import script from "./CompanySelector.vue?vue&type=script&lang=js&"
export * from "./CompanySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports